module.exports = __webpack_public_path__ + "static/media/thakkarbapa_logo.81569718.png";